// extracted by mini-css-extract-plugin
export default {"heading":"ValueProposition_heading__eQ-2J","normal":"ValueProposition_normal__eqD0R","smaller":"ValueProposition_smaller__Od9zJ"};